import packageJson from '../../package.json';

/** Información legal y de producto — panel «Acerca de» */
export const PULSE_ABOUT = {
  legalName: 'SANTA ANA S.R.L.',
  groupName: 'Grupo Santa Ana',
  productName: 'Grupo Bienestar',
  productSubtitle: 'CRM operativo · Farma GSA · Sanatorio Regional & Farmacia',
  version: packageJson.version || '0.1.0'
};

export function getPulseAboutCopyrightYear() {
  return new Date().getFullYear();
}
